export const StandardTrigger = 'GenericApp__StandardTrigger'
export const ScheduleTrigger = 'GenericApp__ScheduleTrigger'
